module.exports = __webpack_public_path__ + "img/qyzztitle1.43096dd1.png";